import React, { useContext, useEffect, useState } from "react";
import Container from "../components/Container";
import { AuthContext } from "../AuthContext";
import { httpRequest } from "../services/http";

const AppCard = ({ app, onAppClick }) => {
    const colorClasses = {
    red: 'bg-card-red',
    blue: 'bg-card-blue',
    orange: 'bg-card-orange',
    teal: 'bg-card-teal',
  };
  return (
    <button
      type="button"
      onClick={() => onAppClick(app)}
      className="card-link hover:shadow-md hover:scale-105 md:h-64 rounded-xl bg-white p-6 transition-all duration-300"
    >
      <div className="h-full">
        <div className="w-14 h-14 bg-slate-100 rounded-lg flex items-center mb-6 justify-center">
            {app.logo_url && (
              <img
                src={app.logo_url}
                alt={app.name}
                className="h-12 w-12 object-contain mb-3"
              />
            )}
        </div>
        <h3 className="text-2xl font-extrabold mb-6 tracking-[0.31px] text-start text-[#034D82] ">{app.name}</h3>
        {app.description && (
          <p className="text-base text-start text-[#717182] font-medium font-segoe tracking-[0%] line-clamp-2 overflow-hidden">{app.description}</p>
        )}
      </div>
    </button>
  );
};

export default function Welcome() {
    const { token } = useContext(AuthContext);
    const [apps, setApps] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      let active = true;
      const fetchApps = async () => {
        try {
          setLoading(true);
          const data = await httpRequest("/applications", {
            headers: token ? { Authorization: `Bearer ${token}` } : {},
          });
          if (!active) return;
          const list = Array.isArray(data?.applications) ? data.applications : [];
          setApps(list);
        } catch (e) {
          console.error("Erreur de chargement des apps", e);
        } finally {
          if (active) setLoading(false);
        }
      };
      fetchApps();
      return () => {
        active = false;
      };
    }, [token]);

    const handleAppClick = (app) => {
      try {
        // ✅ Rediriger DIRECTEMENT avec le token Easy Suite
        const redirectPath = app.redirect_path || "/dashboard";
        const redirectUrl = `${app.frontend_url}${redirectPath}?token=${token}`;

        console.log("🚀 Redirection vers:", redirectUrl);

        // Rediriger l'utilisateur
        window.location.href = redirectUrl;
      } catch (e) {
        console.error("Erreur lors de la redirection", e);
        alert("Erreur de connexion à l'application");
      }
    };

  return (
    // <section id="applications" className="py-16 pb-6 bg-bg-application ">
      <Container className="relative z-10 md:py-16 bg-sky-50">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-4xl font-bold font-inter text-center text-[#191A15] mb-4">
            Bienvenue dans Easy‑Suite
          </h2>
          <p className="text-center text-[#717182] font-regular font-segoe text-base md:text-lg">
            Quelle outil voulez‑vous explorer ?
          </p>
        </div>

        <div className="mt-8">
          {loading ? (
            <div className="text-center text-[#6B7280]">Chargement...</div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {apps.map((app) => (
                <AppCard key={app.id} app={app} onAppClick={handleAppClick} />
              ))}
              {apps.length === 0 && (
                <div className="col-span-full text-center text-[#6B7280]">
                  Aucune application disponible pour le moment.
                </div>
              )}
            </div>
          )}
        </div>
      </Container>
    // </section>
  );
}
